function matchHeights(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  elements.forEach(element => {
    const height = element.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  elements.forEach(element => {
    element.style.minHeight = maxHeight + "px";
  });
}

matchHeights(".index-section-collection .card__content .card__heading");

document.addEventListener("DOMContentLoaded", function () {
  var tabGroups = document.querySelectorAll(".tab-body-flex");

  tabGroups.forEach(function (group) {
    var tabLinks = group.querySelectorAll(".tab-title-content");

    tabLinks.forEach(function (tabLink) {
      tabLink.addEventListener("click", function () {
        var tabs = group.querySelectorAll(".tab-content-block");
        tabs.forEach(function (tab) {
          tab.classList.remove("tab-active");
        });
        
        var dataId = this.getAttribute("data-tab");
        var activeTabs = group.querySelectorAll(
          ".tab-content-block[data-tab='" + dataId + "']"
        );
        activeTabs.forEach(function (activeTab) {
          activeTab.classList.add("tab-active");
        });
        
        tabLinks.forEach(function (link) {
          link.classList.remove("activetab");
        });
        
        this.classList.add("activetab");
        
      });
    });
  });
});

$(".product .metafield-rich_text_field a").click(function(e) {
  e.preventDefault();
  e.stopPropagation();
  console.log("Asd");
  var attr = $(this).attr("href").replace("#", "");
  // Remove # console.log(attr);
  $('html, body').animate({ scrollTop: $('div[id="' + attr + '"]').offset().top - 110
    // Corrected here (remove quotes around the number) 
    }, 2000);
  // Smooth scrolling effect 
});